document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mobile-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const open = !menu.classList.contains('open');
      menu.classList.toggle('open', open);
      document.body.classList.toggle('menu-open', open);
      button.setAttribute('aria-expanded', String(open));
    });
  });
  document.querySelectorAll('[data-mobile-menu-close]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      if (menu) menu.classList.remove('open');
      document.body.classList.remove('menu-open');
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const root = thumb.closest('[data-product-gallery]');
      const main = root?.querySelector('[data-gallery-main]');
      const src = thumb.dataset.image;
      const alt = thumb.dataset.alt || '';
      if (main && src) { main.src = src; main.alt = alt; }
      root?.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  document.querySelectorAll('[data-accordion-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.kb-accordion__item');
      const root = button.closest('.kb-accordion');
      const willOpen = !item.classList.contains('open');
      root?.querySelectorAll('.kb-accordion__item').forEach((i) => i.classList.remove('open'));
      if (willOpen) item.classList.add('open');
      button.setAttribute('aria-expanded', String(willOpen));
    });
  });

  document.querySelectorAll('[data-qty-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const wrap = button.closest('[data-qty]');
      const input = wrap?.querySelector('input[type="number"]');
      if (!input) return;
      const delta = Number(button.dataset.qtyButton || 0);
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + delta);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const variantScript = section.querySelector('[data-product-variants]');
    const idInput = section.querySelector('[data-variant-id]');
    if (!variantScript || !idInput) return;
    let variants = [];
    try { variants = JSON.parse(variantScript.textContent); } catch(e) { return; }

    const updateVariant = () => {
      const selected = [...section.querySelectorAll('[data-option-position]')]
        .map((group) => group.querySelector('input:checked')?.value || '');
      const variant = variants.find((v) => selected.every((value, index) => String(v.options[index]) === String(value)));
      if (!variant) return;
      idInput.value = variant.id;
      const price = section.querySelector('[data-product-price]');
      const compare = section.querySelector('[data-product-compare]');
      const add = section.querySelector('[data-add-to-cart]');
      const stock = section.querySelector('[data-stock-text]');
      if (price) price.textContent = formatMoney(variant.price, section.dataset.moneyFormat || '€{{amount}}');
      if (compare) {
        compare.textContent = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price, section.dataset.moneyFormat || '€{{amount}}') : '';
      }
      if (add) { add.disabled = !variant.available; add.textContent = variant.available ? (add.dataset.availableText || 'In den Warenkorb') : (add.dataset.soldoutText || 'Ausverkauft'); }
      if (stock) stock.textContent = variant.available ? (stock.dataset.availableText || 'Auf Lager') : (stock.dataset.soldoutText || 'Ausverkauft');
      const stockWrap = stock?.closest('.kb-stock');
      if (stockWrap) stockWrap.classList.toggle('kb-stock--out', !variant.available);
      if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };
    section.querySelectorAll('[data-option-position] input').forEach((input) => input.addEventListener('change', updateVariant));
  });

  document.querySelectorAll('[data-recommendations-url]').forEach((container) => {
    const url = container.dataset.recommendationsUrl;
    if (!url) return;
    fetch(url).then((r) => r.text()).then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const replacement = html.querySelector('[data-recommendations-url]');
      if (replacement && replacement.innerHTML.trim()) container.innerHTML = replacement.innerHTML;
    }).catch(() => {});
  });
});

function formatMoney(cents, format){
  const value = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
  return String(format || '€{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, value);
}
